import { c as _c } from "react/compiler-runtime";
import type { HTMLAttributes } from 'react';
import { ModuleIcon } from '#components/Icon/ModuleIcon';
import { filterRelevantModuleType } from '#cutils/articles/filterRelevantModuleType';
import { IconSystem } from '#icons/IconSystem';
import type { ModuleType } from '#types/global';
import styles from './ArticleItemModuleTypes.module.scss';
type Props = {
  modulesTypes?: (ModuleType | null)[];
  isExternal?: boolean;
  isBreakingNews?: boolean;
} & HTMLAttributes<HTMLUListElement>;
export function ArticleItemModuleTypes(t0) {
  const $ = _c(18);
  let className;
  let isBreakingNews;
  let isExternal;
  let modulesTypes;
  let rest;
  if ($[0] !== t0) {
    ({
      modulesTypes,
      isExternal,
      isBreakingNews,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = isBreakingNews;
    $[3] = isExternal;
    $[4] = modulesTypes;
    $[5] = rest;
  } else {
    className = $[1];
    isBreakingNews = $[2];
    isExternal = $[3];
    modulesTypes = $[4];
    rest = $[5];
  }
  let t1;
  if ($[6] !== modulesTypes) {
    t1 = modulesTypes ? modulesTypes.filter(filterRelevantModuleType).map(_temp) : null;
    $[6] = modulesTypes;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const mappedModuleTypes = t1;
  const t2 = `${styles.list} ${className ?? ""}`;
  let t3;
  if ($[8] !== isBreakingNews) {
    t3 = isBreakingNews && <li className={styles.listItem}><IconSystem icon="flash" variant="filled" title="Eilmeldung" size="s" /></li>;
    $[8] = isBreakingNews;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isExternal) {
    t4 = isExternal && <li className={styles.listItem}><IconSystem icon="external-link" variant="outline" title="Externer Link" size="s" /></li>;
    $[10] = isExternal;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== mappedModuleTypes || $[13] !== rest || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <ul className={t2} {...rest}>{t3}{mappedModuleTypes}{t4}</ul>;
    $[12] = mappedModuleTypes;
    $[13] = rest;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}
function _temp(moduleType) {
  return <li className={styles.listItem} key={moduleType}><ModuleIcon moduleType={moduleType} size="s" /></li>;
}